import { date, object, string } from 'yup';

export const AppointmentRescheduleSchema = object().shape({
  status: string().required(),
  date: date().required(),
  rescheduledBy: string(),
  rescheduledAt: date(),
});
